import { useEffect } from 'react';
import { useEqMemoize } from './useEqMemoize';
export var useStableEffect = function (callback, dependencies, eq, options) {
    return useEffect(callback, useEqMemoize(dependencies, eq, options));
};
//# sourceMappingURL=effect.js.map